<template>
  <div
    class="flex size-full flex-col items-center justify-center"
  >
    <main
      class="flex size-full flex-col items-stretch justify-center sm:max-w-lg sm:p-4"
    >
      <BaseCard
        class="min-h-full overflow-y-auto sm:min-h-0"
      >
        <div class="flex items-center justify-center py-4">
          <IconBeepaidLogo />
        </div>
        <RouterView />
      </BaseCard>
    </main>
  </div>
</template>
